module.exports = __webpack_public_path__ + "img/YF-DH.87c77cd3.png";